import windowBind from './modules/_windowBind';
import HeroFit from './modules/_HeroFit';

let heroFit = new HeroFit();



windowBind.$target.on('load',()=>{
    heroFit.setEvents();
});

windowBind.$target.on('resize', ()=>{
    heroFit.resizeEvents();
});